import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { GlobalState } from "src/types/storeTypes/global";

const ACTIVE_PROFILE_KEY = "activeMarriageProfileId";

const initialState: GlobalState = {
  globalLanguage:
    (typeof window !== "undefined" && window.localStorage
      ? window.localStorage.getItem("lang")
      : null) || "EN",
  activeMarriageProfileId:
    typeof window !== "undefined" && window.localStorage.getItem(ACTIVE_PROFILE_KEY)
      ? Number(window.localStorage.getItem(ACTIVE_PROFILE_KEY))
      : null,
};

const setGlobalInfoReducer = (
  state: GlobalState,
  action: PayloadAction<Partial<GlobalState>>
): GlobalState => {
  const next = { ...state, ...action.payload };
  // Persist active profile id
  if ("activeMarriageProfileId" in action.payload) {
    const id = action.payload.activeMarriageProfileId;
    if (id != null) {
      window.localStorage.setItem(ACTIVE_PROFILE_KEY, String(id));
    } else {
      window.localStorage.removeItem(ACTIVE_PROFILE_KEY);
    }
  }
  return next;
};

const globalInfoSlice = createSlice({
    initialState,
    name: "global",
    reducers: {
        setGlobalInfo: setGlobalInfoReducer,
    },
});

export const { setGlobalInfo } = globalInfoSlice.actions;
export default globalInfoSlice.reducer;